/** Home + list shelves for top movies on major streaming services (tvOS parity). */

export const STREAMING_PROVIDER_SHELF_MIN_VOTES = 100_000;
export const STREAMING_PROVIDER_SHELF_MAX_VOTES = 2_000_000;
/** Home streaming provider shelves: movies released in 2001 or later. */
export const STREAMING_PROVIDER_HOME_MIN_YEAR = 2001;
export const STREAMING_PROVIDER_HOME_RELEASE_GTE = "2001-01-01";

export const HOME_STREAMING_PROVIDER_SHELVES = [
  { key: "streaming-prime", label: "Prime", provider: "Amazon Prime Video" },
  { key: "streaming-netflix", label: "Netflix", provider: "Netflix" },
  { key: "streaming-max", label: "Max", provider: "Max" },
  { key: "streaming-disney", label: "Disney+", provider: "Disney Plus" },
  { key: "streaming-paramount", label: "Paramount+", provider: "Paramount Plus" },
  { key: "streaming-hulu", label: "Hulu", provider: "Hulu" },
];

export const HOME_STREAMING_PROVIDER_LIST_KEYS = new Set(
  HOME_STREAMING_PROVIDER_SHELVES.map((shelf) => shelf.key),
);

export function buildStreamingProviderListRequest(provider) {
  const releaseGte = encodeURIComponent(STREAMING_PROVIDER_HOME_RELEASE_GTE);
  return `/api/3/discover/movie?sort_by=curator_score.desc&with_watch_providers=${encodeURIComponent(provider)}&vote_count.gte=${STREAMING_PROVIDER_SHELF_MIN_VOTES}&vote_count.lte=${STREAMING_PROVIDER_SHELF_MAX_VOTES}&with_original_language=en&primary_release_date.gte=${releaseGte}`;
}

export function streamingProviderReleaseYear(row) {
  const year = Number(row?.year);
  if (Number.isFinite(year) && year > 0) return year;
  const raw = row?.release_date ?? row?.releaseDate ?? null;
  if (raw) {
    const parsed = Number(String(raw).slice(0, 4));
    if (Number.isFinite(parsed) && parsed > 0) return parsed;
  }
  return null;
}

export function passesStreamingProviderReleaseYear(row) {
  const year = streamingProviderReleaseYear(row);
  return year == null || year >= STREAMING_PROVIDER_HOME_MIN_YEAR;
}

export function buildHomeStreamingProviderListConfig() {
  return Object.fromEntries(
    HOME_STREAMING_PROVIDER_SHELVES.map((def) => [
      def.key,
      {
        label: def.label,
        subtitle: "Top movies · Curator score · 2001+",
        request: buildStreamingProviderListRequest(def.provider),
        mediaType: "movie",
        streamingProvider: def.provider,
      },
    ]),
  );
}

export function streamingProviderForListKey(listKey) {
  return HOME_STREAMING_PROVIDER_SHELVES.find((shelf) => shelf.key === listKey)?.provider || null;
}
